// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin: 10px;
}

h1 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: var(--ion-color-dark);
}

h2 {
  font-size: 20px;
  font-weight: 500;
  margin: 15px 0;
  color: var(--ion-color-dark);
}

.article {
  margin-bottom: 25px;
}

.article p {
  margin: 10px 0;
  line-height: 1.5;
  color: var(--ion-color-dark);
}

.article ul {
  padding-left: 20px;
  margin: 10px 0;
}

.article li {
  margin: 5px 0;
  line-height: 1.5;
  color: var(--ion-color-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/account/mentions/mentions.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAEE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;AACJ;;AAEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AACJ;;AAEE;EACE,mBAAA;AACJ;;AAEE;EACE,cAAA;EACA,gBAAA;EACA,4BAAA;AACJ;;AAEE;EACE,kBAAA;EACA,cAAA;AACJ;;AAEE;EACE,aAAA;EACA,gBAAA;EACA,4BAAA;AACJ","sourcesContent":[".content-container {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    margin: 10px;\r\n  }\r\n  \r\n  h1 {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    margin-bottom: 20px;\r\n    color: var(--ion-color-dark);\r\n  }\r\n  \r\n  h2 {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin: 15px 0;\r\n    color: var(--ion-color-dark);\r\n  }\r\n  \r\n  .article {\r\n    margin-bottom: 25px;\r\n  }\r\n  \r\n  .article p {\r\n    margin: 10px 0;\r\n    line-height: 1.5;\r\n    color: var(--ion-color-dark);\r\n  }\r\n  \r\n  .article ul {\r\n    padding-left: 20px;\r\n    margin: 10px 0;\r\n  }\r\n  \r\n  .article li {\r\n    margin: 5px 0;\r\n    line-height: 1.5;\r\n    color: var(--ion-color-dark);\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
